import styled from '@emotion/styled';
import { Dialog } from '@mui/material';

import { Buttons } from 'components/modal/styles';

export const Header = styled.div(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  fontSize: 14,
  fontWeight: 500,
}));

export const PanelContent = styled.div(() => ({
  padding: 10,
}));

export const RemoteSelectWrapper = styled.div(() => ({
  width: 290,
}));

export const ButtonWrapper = styled.div(() => ({
  margin: '0 auto',
  maxWidth: 155,
}));

export const StyledConfirmationDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    maxWidth: 461,
  },
}));

export const ConfirmationModalContent = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 15,
  padding: '20px 10px 30px',
}));

export const ConfirmationLabel = styled.div((props) => ({
  fontSize: 14,
  fontWeight: 400,
  color: props.theme.colors.text.secondary,
}));

export const ConfirmationAmount = styled.div((props) => ({
  fontSize: 24,
  fontWeight: 600,
  color: props.theme.colors.text.primary,
}));

export const ConfirmationTo = styled.div((props) => ({
  fontSize: 14,
  fontWeight: 400,
  color: props.theme.colors.text.secondary,
}));

export const ConfirmationEmail = styled.div((props) => ({
  fontSize: 18,
  color: props.theme.colors.text.primary,
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
  textAlign: 'center',
  maxWidth: '100%',
  padding: '0 10px',
}));

export const Delimiter = styled.div(({ theme }) => ({
  height: 1,
  background: theme.colors.container.secondary,
  width: '100%',
  marginBottom: 20,
}));

export const StyledButtons = styled(Buttons)(() => ({
  paddingBottom: 20,
}));
